export const emailCampaignsKeys = {
	all: ['emailCampaigns'],
	list: () => ['emailCampaigns', 'list'],
	detail: (id) => ['emailCampaigns', 'detail', id],
	statusEnum: ['emailCampaigns', 'statusEnum'],
	kpis: () => ['emailCampaigns', 'kpis'],
};

export const emailCampaignsMutationKeys = {
	create: ['emailCampaigns', 'create'],
	update: ['emailCampaigns', 'update'],
	delete: ['emailCampaigns', 'delete'],
	upsertLists: ['emailCampaigns', 'upsertLists'],
	removeRecipient: ['emailCampaigns', 'removeRecipient'],
};
